import Contact from './Contact';

export default Contact;



// WEBPACK FOOTER //
// ./src/Contact/index.js